module.exports = __webpack_public_path__ + "static/20210308_142048-48190e995ec68467b68b8fa44945566b.webp";